<template>
<div class="cui-applications__search cui-applications__search-results">
    <div class="cui-action">
        <div class="cui-action__title">{{$vuetify.lang.t('$vuetify.new-request')}}</div>
        <div class="cui-action__actions">

            <!-- close icon -->

            <svg @click="$router.push('/applications/request')" xmlns="http://www.w3.org/2000/svg" class="cui-action__icon cui-action__icon--close" preserveAspectRatio="xMidYMid meet" viewBox="2 0 48 48">
                <defs>
                  <ellipse id="path-1" cx="20" cy="19.672" rx="20" ry="19.672"/>
                  <filter x="-50%" y="-50%" width="200%" height="200%" filterUnits="objectBoundingBox" id="filter-2">
                    <feOffset dy="3" in="SourceAlpha" result="shadowOffsetOuter1"/>
                    <feGaussianBlur stdDeviation="2" in="shadowOffsetOuter1" result="shadowBlurOuter1"/>
                    <feColorMatrix values="0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.27 0" in="shadowBlurOuter1"/>
                  </filter>
                </defs>
                <g id="close-with-shadow" fill="none" fill-rule="evenodd">
                    <g id="Oval-73" transform="translate(3 1)">
                        <use fill="#000" filter="url(#filter-2)" xlink:href="#path-1"/>
                        <use fill="currentColor" xlink:href="#path-1"/>
                    </g>
                    <path d="M26.022 20.672l4.006-4.006c.788-.787.787-2.052.006-2.833l-.195-.195c-.788-.787-2.05-.778-2.834.006L23 17.65l-4.006-4.006c-.787-.788-2.052-.787-2.833-.006l-.194.195c-.788.787-.778 2.05.006 2.833l4.006 4.006-4.006 4.006c-.788.787-.787 2.053-.006 2.833l.195.196c.788.788 2.05.778 2.834-.006L23 23.695l4.006 4.005c.787.788 2.052.787 2.833.006l.194-.195c.788-.786.778-2.048-.006-2.832l-4.006-4.006z" fill="#fff"/>
                </g>
            </svg>
        </div>
    </div>
    <div class="cui-action cui-action--alt">
        <div class="cui-action__title cui-action__title-link"  @click="$router.push('/applications/request')">&#60; {{$vuetify.lang.t('$vuetify.categories')}}</div>
        <span class="cui-action__title" ng-if="category"> {{category}}</span>
        <div class="cui-input-button cui-input-button--alt-bg">
            <input class="cui-input-button__input" ng-model="applicationSearch.search.name" focus-if placeholder="Search by Application name" on-enter="applicationSearch.updateSearch"/>
            <button class="cui-input-button__button" ng-click="applicationSearch.updateSearch('name')">{{$vuetify.lang.t('$vuetify.filter')}}</button>
        </div>
        <div class="cui-action__actions">
            <svg cui-icon id="cui-applications__requested-apps" ng-click="applicationSearch.requestPopover=!applicationSearch.requestPopover" off-click="applicationSearch.requestPopover=false" xmlns="http://www.w3.org/2000/svg" class="cui-icon--folder" ng-class="{'cui-action__icon--active': applicationSearch.numberOfRequests != 0}" preserveAspectRatio="xMidYMid meet" viewBox="0 0 40 33">
              <use class="cui-icon__ref" xlink:href="node_modules/@covisint/cui-icons/dist/icons/icons-out.svg#folder"></use>
            </svg>
            <sup class="cui-action__icon-counter" v-if="numberOfRequests > 0">{{numberOfRequests}}</sup>
            <b-popover class="cui-action__popover cui-popover--positionless" target="cui-applications__requested-apps" triggers="hover focus" placement="bottom">
               <template v-slot:title>
                  <span>{{$vuetify.lang.t('$vuetify.collected-items-for-request')}}</span>
              </template>
              <div class="cui-action__popover-section">
                  <span class="cui-action__popover-title" v-if="numberOfRequests === 0">{{$vuetify.lang.t('$vuetify.no-selected-apps')}}<br/></span>
                   <ul ng-if="numberOfRequests > 0">
                    <li v-for="(packageRequest,indexApp) in packageRequests" :key="indexApp">{{packageRequest.name[0].text}}</li>
                  </ul>
              </div>
            </b-popover>
            <!-- <div cui-popover class="cui-action__popover cui-popover--positionless" target="#cui-applications__requested-apps" pointer-height="13" pointer-width="10" popover-positions="[{position:'bottom',contentOffset:'-70px'}, 'any']" ng-if="applicationSearch.requestPopover">
              <span class="cui-action__popover-title">{{'collected-items-for-request' | translate}}</span>
              <div class="cui-action__popover-section">
                <span ng-if="applicationSearch.numberOfRequests === 0">{{'no-selected-apps' | translate}}<br/></span>
                <ul ng-if="applicationSearch.numberOfRequests > 0">
                    <li ng-repeat="(applicationId,application) in applicationSearch.packageRequests">{{application.name | cuiI18n}}</li>
                </ul>
              </div>
              <span ng-if="applicationSearch.numberOfRequests > 0" class="cui-action__popover-button" ui-sref="applications.reviewRequest">{{'submit-request' | translate}}</span>
              <br>
              <span ng-if="applicationSearch.numberOfRequests > 0" class="cui-action__popover-button" href="" ng-click="applicationSearch.clear()">Clear All</span>
            </div> -->
        </div>
    </div>

    <div class="cui-applications__main-container">
      <div class="cui-loading__container" v-if="spinner">
    <div class="cui-loading--center"><div class="cui-loading"></div></div>
  </div>
        <p class="cui-users__password-success" style=" margin:20px; text-align:center" v-if="appCount===0">{{$vuetify.lang.t('$vuetify.no-apps-found')}} <span ng-if="applicationSearch.search.name">{{'refine-search' |translate}}</span> </p>
        <!-- <v-expansion-panels style="width:75%"> -->
         <div class="cui-expandable" style="width:90%" v-for="(application,index) in appslist" :key="index">
            <!-- <cui-expandable-title class="cui-expandable__title cui-expandable__title--flex" >
                <div class="cui-applications__expandable-info" ng-click="toggleExpand()">
                    <h3 class="cui-expandable__title-left">{{application[0].name}}</h3>
                </div>
                <div class="cui-expandable__title-end">
                    <span class="cui-checkbox__container">
                        <input class="cui-checkbox" type="checkbox" ng-model="applicationSearch.appCheckbox[application.id]" />
                        <label class="cui-checkbox__label" ng-click="applicationSearch.appCheckbox[application.id]=!applicationSearch.appCheckbox[application.id]; applicationSearch.toggleRequest(application);applicationSearch.checkRelatedAndBundledApps(application)"></label>
                    </span>
                </div>
                <svg cui-icon xmlns="http://www.w3.org/2000/svg" class="cui-icon cui-icon--light-grey chevron" ng-class="{'cui-hide__opacity': (!application.bundledApps || application.bundledApps.length===0) && (application.servicePackage.parent || (!application.relatedApps || application.relatedApps.length===0))}" preserveAspectRatio="xMidYMid meet" viewBox="0 0 216 146" ng-click="toggleExpand()">
                  <use class="cui-icon__ref" xlink:href="node_modules/@covisint/cui-icons/dist/font-awesome/font-awesome-out.svg#chevron18"></use>
                </svg>
            </cui-expandable-title> -->
             <div class="cui-applications__expandable-info">
              <h3 class="cui-action__title" style="flex:0.9">{{application.name[0].text}}</h3>
              <div class="cui-expandable__title-end"><v-checkbox  v-model="selectedApplications[index]" @change="updateAppsCount(application,index)" checked="false"></v-checkbox></div>
             </div>
<!-- <div class="cui-expandable__title-end">
             <v-checkbox  @change="updateAppsCount(application)" checked="false"></v-checkbox>
</div> -->
            <!-- <cui-expandable-body class="cui-expandable__body" >
                <div class="cui-expandable__body-pane" ng-if="(application.bundledApps && application.bundledApps.length!==0) || (!application.servicePackage.parent && (application.relatedApps && application.relatedApps.length!==0))">
                    <span class="cui-expandable__body-close" ng-click="collapse()">
                        <svg xmlns="http://www.w3.org/2000/svg" class="cui-icon" preserveAspectRatio="xMidYMid meet" viewBox="2 0 48 48">
                          <use class="cui-icon__ref" xlink:href="node_modules/@covisint/cui-icons/dist/icons/icons-out.svg#close-no-fill"></use>
                        </svg>
                    </span>
                    <span ng-if="(!application.bundledApps || application.bundledApps.length===0) && (application.servicePackage.parent || (!application.relatedApps || application.relatedApps.length===0))">{{'no-bundled-or-related' | translate}}</span>
                    <div class="cui-expandable__pane-col" ng-if="application.bundledApps && application.bundledApps.length > 0">
                        <h4 class="cui-expandable__pane-title">{{'bundled-applications' | translate}}</h4>
                        <div class="cui-expandable__pane-content">
                            <span class="cui-expandable__pane-content-item" ng-repeat="bundledApp in application.bundledApps">
                                {{bundledApp.name | cuiI18n}}
                            </span>
                        </div>
                    </div>
                    <div class="cui-expandable__pane-col" ng-if="!application.servicePackage.parent && application.relatedApps && application.relatedApps.length > 0">
                        <h4 class="cui-expandable__pane-title">{{'related-applications' | translate}}</h4>
                        <div class="cui-expandable__pane-content">
                            <span class="cui-expandable__pane-content-item" ng-repeat="relatedApp in application.relatedApps">
                                <span class="cui-checkbox_label__flex">{{relatedApp.name | cuiI18n}} </span>
                                <span class="cui-checkbox__container">
                                    <input class="cui-checkbox" type="checkbox" ng-model="applicationSearch.appCheckbox[relatedApp.id]" />
                                    <label class="cui-checkbox__label" ng-click="applicationSearch.appCheckbox[relatedApp.id]=!applicationSearch.appCheckbox[relatedApp.id];applicationSearch.checkRelatedAppsBody(relatedApp,application)"></label>
                                </span>
                            </span>
                        </div>
                    </div>
                </div>
            </cui-expandable-body> -->
         </div>
        <!-- </v-expansion-panels> -->
      <div class="cui-paginate__container">
      <span class="cui-paginate__results-label">Results per page</span>
        <select  class="cui-paginate__select custom_paginate"
        v-model="pagination.perPage" @change="getPagination">
        <option
          v-for="entry in pagination.intervals"
          :key="entry"
          :value="entry"
        >{{ entry }}</option>
      </select>
  <div class="mt-3">
      <b-pagination v-model="currentPage" :per-page="perPage" :total-rows="rows" size="lg" @change="getPagination" align="left">
      </b-pagination>
  </div>
</div>

        <!-- search button -->

        <div class="cui-applications__search-button">
            <button style="margin-right:170px" class="cui-button" ng-class="{'cui-button--error' :numberOfRequests===0}" @click="numberOfRequests != 0 && saveRequestsAndCheckout()">{{'review-request' | translate}}</button>
        </div>
    </div>
</div>
</template>
<script>
export default {
  data () {
    return {
      pagination: {
        rows: null,
        perPage: 50,
        currentPage: 1,
        intervals: [10, 25, 50, 100, 200]
      },
      spinner: false,
      appslist: [],
      appCount: 0,
      search: {},
      numberOfRequests: 0,
      applnsCategorylist: [],
      selectedApplications: [],
      packageRequests: []
    }
  },
  props: {
    category: {
      type: String,
      default: null
    }
  },
  computed: {
    userData () {
      return this.$store.getters.getUserInfo
    }
  },
  created () {
    const onLoad = () => {
      this.spinner = true
      this.search.pageSize = this.pagination.perPage
      this.search.page = this.pagination.currentPage
      let query = []
      // if (applicationSearch.search.name) {
      //     query.push(['service.name',applicationSearch.search.name]);
      // }
      if (this.category) {
        query.push(['service.category', this.category])
      }
      query.push(['pageSize', this.search.pageSize])
      query.push(['page', this.search.page])
      let opts = {
        personId: this.userData.user.id,
        useCuid: true,
        qs: query
      }
      const promises = [this.$API.getPersonRequestableApps(opts), this.$API.getPersonRequestableCount(opts)]

      Promise.all(promises)
        .then(res => {
          this.appslist = res[0]
          this.appCount = res[1]
          this.spinner = false
          const storageData = {
            appsList: res[0],
            appCount: res[1]
          }
          localStorage.setItem('appsListData', JSON.stringify(storageData))
        })
        .catch(err => {
          this.spinner = false
          console.log('There was an error in fetcting user\'s granted applications ' + err)
        })
        .finally(() => {
          this.spinner = false
        })
    }
    onLoad()
  },
  methods: {
    getPagination () {
      this.onLoad(false)
    },
    updateAppsCount (application, index) {
      if (this.selectedApplications[index]) {
        this.numberOfRequests++
        this.packageRequests.push(application)
      } else if (!this.selectedApplications[index] && this.numberOfRequests > 0) {
        this.numberOfRequests--
        this.packageRequests.pop(application)
      } else {
        this.numberOfRequests = 0
      }

      localStorage.setItem('packageRequests', this.packageRequests)

      // this.$router.push('/applications/review')
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/pages/applications/SearchCategory.vue